/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createZeros } from '../../factoriesAny.js';
export var zerosDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createZeros: createZeros
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesZeros.generated.js
// module id = 125
// module chunks = 0